import { Link } from "react-router-dom";
import { allProducts } from "@/mocks/products";

export default function LatestProducts() {
  const featured = allProducts.slice(0, 6);

  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <div className="inline-flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
              <span className="text-[11px] tracking-[0.22em] uppercase text-accent-700 font-semibold">
                Latest Products
              </span>
            </div>
            <h2 className="mt-4 font-heading font-extrabold text-foreground-950 text-3xl md:text-[42px] leading-tight tracking-tight">
              주요 제품
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-2xl leading-relaxed">
              자동차부터 중공업까지, 다양한 산업 현장에 공급되는
              한국고무공업의 대표 제품을 만나보세요.
            </p>
          </div>
          <div className="flex items-center gap-3">
            <Link
              to="/products"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-full border border-foreground-950/15 text-foreground-900 hover:bg-foreground-950 hover:text-background-50 text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap self-start md:self-auto"
            >
              전체 제품 보기
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" />
              </span>
            </Link>
            <Link
              to="/quotation"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              견적 요청
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" />
              </span>
            </Link>
          </div>
        </div>

        <div
          className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6"
          data-product-shop
        >
          {featured.map((p, idx) => (
            <Link
              key={p.id}
              to={`/products/${p.id}`}
              className="group relative bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="relative aspect-square overflow-hidden bg-background-200">
                <img
                  src={p.image}
                  alt={`${p.name} - ${p.application} 산업용 고무제품`}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
                />
                <div className="absolute top-4 left-4 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-background-50/95 backdrop-blur text-[11px] font-semibold text-foreground-900">
                  {p.category}
                </div>
                <div className="absolute top-4 right-4 text-[11px] font-mono tracking-widest text-background-50 bg-foreground-950/60 backdrop-blur px-2 py-1 rounded-md">
                  {String(idx + 1).padStart(2, "0")} / {String(featured.length).padStart(2, "0")}
                </div>
              </div>
              <div className="p-6 md:p-7">
                <h3 className="font-heading font-bold text-foreground-950 text-lg md:text-xl">
                  {p.name}
                </h3>
                <div className="mt-3 flex flex-wrap gap-2 text-[11px]">
                  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-background-200/70 text-foreground-700">
                    <i className="ri-building-line" />
                    {p.application}
                  </span>
                  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-background-200/70 text-foreground-700">
                    <i className="ri-flask-line" />
                    {p.material}
                  </span>
                </div>
                <div className="mt-6 pt-5 border-t border-background-200/80 flex items-center justify-between">
                  <span className="text-[11px] tracking-[0.2em] uppercase text-foreground-500 font-semibold">
                    상세 보기
                  </span>
                  <span className="w-9 h-9 rounded-full bg-foreground-950 text-background-50 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-arrow-right-up-line text-base" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}